import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { messengersApi } from 'apis/messengers';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { createAppModal } from 'utils/modal';
import { AddSecretModalComponent } from './addSecretModalComponent';
import { DeleteSecretModalComponent } from './deleteSecretModalComponent';
import { EditSecretModalComponent } from './editSecretModalComponent';
/** Modal for managing messenger secret. */
export const MessengerSecretModal = createAppModal({ type: 'settings:messengerSecret' }, ({ isOpen, modal, hide }) => {
    const { action, messengerId } = modal.arg;
    const [generateSecret] = messengersApi.useGenerateSecretMutation();
    const [createSecret] = messengersApi.useCreateSecretMutation();
    const [updateSecret] = messengersApi.useUpdateSecretMutation();
    const [deleteSecret] = messengersApi.useDeleteSecretMutation();
    const notify = useNotifications();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [autoGeneratedSecret, setAutoGeneratedSecret] = useState();
    const handleOnError = (title) => (_error) => {
        notify({ title }, NotificationType.Error);
        setIsSubmitting(false);
    };
    const handleOnSuccess = (text) => {
        notify({ title: 'Success', text, icon: 'i-done', time: 5000 }, NotificationType.Success);
    };
    const handleOnAdd = (secret) => {
        setIsSubmitting(true);
        createSecret(Object.assign(Object.assign({}, secret), { messengerId }))
            .unwrap()
            .then(() => {
            handleOnSuccess('Key has been created.');
            hide === null || hide === void 0 ? void 0 : hide();
        })
            .catch(handleOnError('An error occurred while creating the key.'));
    };
    const handleOnEdit = ({ id, description }) => {
        setIsSubmitting(true);
        updateSecret({
            messengerId,
            secretId: id,
            description,
        })
            .unwrap()
            .then(() => {
            handleOnSuccess('Key description has been updated.');
            hide === null || hide === void 0 ? void 0 : hide();
        })
            .catch(handleOnError('An error occurred while updating the key.'));
    };
    const handleOnDelete = (secretId) => {
        setIsSubmitting(true);
        deleteSecret({ messengerId, secretId })
            .then(() => {
            handleOnSuccess('Key has been deleted.');
            hide === null || hide === void 0 ? void 0 : hide();
        })
            .catch(handleOnError('An error occurred while deleting the key.'));
    };
    useEffect(() => {
        if (action.type === 'add' && autoGeneratedSecret === undefined) {
            generateSecret()
                .unwrap()
                .then((x) => setAutoGeneratedSecret(x.secret))
                .catch(handleOnError('An error occurred while generating key.'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return action.type === 'add' ? (_jsx(AddSecretModalComponent, { isOpen: isOpen, isSubmitting: isSubmitting, autoGeneratedSecret: autoGeneratedSecret, onAdd: handleOnAdd, hide: hide })) : action.type === 'update' ? (_jsx(EditSecretModalComponent, { isOpen: isOpen, isSubmitting: isSubmitting, secret: action.secret, onEdit: handleOnEdit, hide: hide })) : (_jsx(DeleteSecretModalComponent, { isOpen: isOpen, isSubmitting: isSubmitting, id: action.secretId, onDelete: handleOnDelete, hide: hide }));
});
